import { type Account } from './accounts';
import { baseUrl } from './config';

export const linkToAccount = (account: Account) => `${baseUrl()}/accounts/${account._id}`;
